// Generated by Claude Code
import { PeriodicMaintenancesPage } from '#components/domain/operations/periodic-maintenances/periodic-maintenances-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/periodic-maintenances/')({
  component: RouteComponent,
  staticData: {
    title: 'Periodic Maintenance',
  },
})

function RouteComponent() {
  // Limited readers (any READ_LIMITED slot) may enter; the backend + limited-
  // access whitelists decide which properties they actually see.
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.PERIODIC_MAINTENANCES)} redirectOnNotAuthorized>
      <PeriodicMaintenancesPage />
    </PermissionGuard>
  )
}
